<!--  FINANCE STATUS  -->

<div class="result">
	<ng-container *ngIf="!quote.is_eligible_for_finance_manager">
		<!--  HEADING  -->

		<div class="heading">
			<i class="icon-tick" [ngClass]="isProcessed() || isSubmitted() ? 'pri-fg pri-bg' : 'pos-fg pos-bg'"></i>
			<h3>{{ getDisplayStatus() }}!</h3>
		</div>

		<!--  END HEADING  -->

		<!--  APPROVED OPENING MESSAGE  -->

		<div *ngIf="isApproved()" class="written-content padded">
			<h3>
				You have been {{ quote.quote_status === 'ConditionallyApproved' ? 'conditionally ' : null }}approved for
				finance!
			</h3>
			<p>
				Following your recent application, we're delighted to let you know that you have been
				{{ quote.quote_status === 'ConditionallyApproved' ? 'conditionally ' : null }}approved for finance.
			</p>
		</div>

		<!--  END APPROVED OPENING MESSAGE  -->

		<!--  PROCESSED OPENING MESSAGE  -->

		<div *ngIf="isProcessed()" class="written-content padded">
			<h3>Your finance application has been processed!</h3>
			<p>
				Following your recent application, we're just letting you know that your application has been processed.
			</p>
		</div>

		<!--  END PROCESSED OPENING MESSAGE  -->

		<!-- SUBMITTED OPENING MESSAGE -->
		<div *ngIf="isSubmitted()" class="written-content padded">
			<h3>Your finance application has been submitted!</h3>
			<p>
				Following your recent application, we're just letting you know that your application has been submitted.
			</p>
		</div>
		<!-- END SUBMITTED OPENING MESSAGE -->
	</ng-container>

	<ng-container *ngIf="quote.is_eligible_for_finance_manager">
		<div class="heading">
			<i [ngClass]="getActualStatus().icon"></i>
			<h3>{{ getActualStatus().friendly_name }}</h3>
		</div>

		<!--  END HEADING  -->

		<!--  APPROVED OPENING MESSAGE  -->

		<div class="written-content padded">
			<h3>Need to manage your application?</h3>
			<p>
				{{ getOpeningMessage() }}
			</p>
		</div>
	</ng-container>

	<!--  QUOTE DETAILS  -->

	<div class="accordion">
		<div class="accordion-item" [ngClass]="{ active: quote_expanded }">
			<h2 class="accordion-item-label" (click)="quote_expanded = !quote_expanded">
				Quote Details
				<i class="icon-chevron-down text-hl" [class.expanded]="quote_expanded"></i>
			</h2>
			<div class="accordion-item-content">
				<cng-finance-quote
					[quote]="quote"
					[breakdown_alignment]="'vertical'"
					[show_info]="false"
					[show_status]="false"
					[show_disclaimer]="true"
					[show_vat_disclaimer]="vehicle.add_vat"
				></cng-finance-quote>
			</div>
		</div>
	</div>

	<!--  END QUOTE DETAILS  -->

	<ng-container *ngIf="!quote.is_eligible_for_finance_manager">
		<!--  APPROVED CLOSING MESSAGE  -->

		<div *ngIf="isApproved() && !reserved" class="written-content padded">
			<h3>What next?</h3>
			<p>
				Now that you're safe in the knowledge that you can
				{{ quote.quote_status === 'ConditionallyApproved' ? 'conditionally ' : null }}finance your new vehicle,
				you should go ahead and reserve now to avoid disappointment!
			</p>
		</div>

		<!--  END APPROVED CLOSING MESSAGE  -->

		<!--  PROCESSED CLOSING MESSAGE  -->

		<div *ngIf="isProcessed() || isSubmitted() || reserved" class="written-content padded">
			<h3>What next?</h3>
			<p>
				We would like to discuss the next steps with you to finalise your deal. Please arrange a callback with
				one of our experienced and helpful sales staff.
			</p>
		</div>

		<!--  END APPROVED CLOSING MESSAGE  -->
	</ng-container>

	<div *ngIf="quote.is_eligible_for_finance_manager" class="button-container">
		<a class="button primary-button" (click)="onManageApplication()">Manage Application</a>
	</div>
</div>

<!--  END FINANCE STATUS  -->
